module.exports = __webpack_public_path__ + "static/media/icon-twitter.7961c39a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-twitter.svg
// module id = 402
// module chunks = 2